module.exports = __webpack_public_path__ + "img/ice-tea.d9d18ecd.svg";